import { Component, OnInit,Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { PM_Duration_Interface } from 'src/app/Interface/PM_Duration_Interface';
import { PM_Itme_Interface } from 'src/app/Interface/PM_Itme_Interface';
import { Empty_PM_Program_Interface, PM_Program_Interface } from 'src/app/Interface/PM_Program_Interface';
import { User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { PM_DurationService } from 'src/app/Service/PM/PM_Duration.service';
import { PM_ItemService } from 'src/app/Service/PM/PM_Item.service';
import { PM_ProgramService } from 'src/app/Service/PM/PM_Program.service';

@Component({
  selector: 'app-PMProgramForm',
  templateUrl: './PMProgramForm.component.html',
  styleUrls: ['./PMProgramForm.component.css']
})
export class PMProgramFormComponent implements OnInit {

  @Input() inner_PM: PM_Program_Interface = Empty_PM_Program_Interface()




  constructor(
    private PM_Program_Service: PM_ProgramService,
    private PM_Duration_Service: PM_DurationService,
    private PM_Item_Service: PM_ItemService,
    private Nav_Service: NavService,
    private Alertify_Service: AlertifyService,
  ) { }

  ngOnInit() {

    this.PMForm = new FormGroup({
      id: new FormControl(),
      Title: new FormControl(null, Validators.required),
      Duration: new FormControl(null, Validators.required),
    })

    this.Nav_Service.CheckValidPage(1159).subscribe(
      data => {
        this.get_Form_Title().setValue(this.inner_PM.title)
        this.get_Form_Duration().setValue(this.inner_PM.duration_id)
        this.Read_PM_Duration()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )

  }

  //#region PM Duration

  DataList_PM_Duration: Array<PM_Duration_Interface> = []
  Read_PM_Duration() {
    this.PM_Duration_Service.GetActive().subscribe(
      data => {
        this.DataList_PM_Duration = data
        this.Read_PM_Item()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  //#endregion

  //#region  Form

  PMForm: FormGroup;

  get_Form_Title() {
    return this.PMForm.get('Title') as FormControl;
  }

  get_Form_Duration() {
    return this.PMForm.get('Duration') as FormControl;
  }

  //#endregion

  //#region PM Item

  DataList_PM_Item: Array<PM_Itme_Interface> = []
  Read_PM_Item() {
    this.PM_Item_Service.GetActive(this.inner_PM.id).subscribe(
      data => {
        this.DataList_PM_Item = data
        this.Read_User()
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  item_Data_Change(item: PM_Itme_Interface)
  {
    item.selected=!item.selected
  }

  //#endregion

  //#region User

  DataList_User: Array<User_Interface> = []
  Read_User() {
    this.PM_Program_Service.GetUser(this.inner_PM.id).subscribe(
      data => {
        this.DataList_User=data
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  user_Data_Change(item: User_Interface)
  {
    item.del=!item.del
  }

  //#endregion

  InProccessing: boolean = false

  SubmitPMForm() {
    var Record: PM_Program_Interface = Empty_PM_Program_Interface()
    Record.id = this.inner_PM.id
    Record.title = this.get_Form_Title().value
    Record.duration_id = Number(this.get_Form_Duration().value)


    var SelectedItem: Array<number> = []
    for (let item of this.DataList_PM_Item)
    {
      for (let item2 of item.detail)
      {
        if (item2.selected)
        {
          SelectedItem.push(item2.id)
        }
      }
    }

    var SelectedUser: Array<number> = []
    for (let item of this.DataList_User)
    {
      if (item.del)
      {
        SelectedUser.push(item.id)
      }
    }

    if (Record.duration_id == 0 || !Record.duration_id) {
      this.Alertify_Service.ErrorMessage("دوره سرویس را انتخاب نمائید")
    }
    else {
      this.InProccessing = true
      this.PM_Program_Service.AddEditPM(Record,
        SelectedItem,
        SelectedUser).subscribe(
        data => {
          this.InProccessing = false
          if (data.id == -2) {
            this.Alertify_Service.ErrorMessage("عنوان وارد شده در سامانه ثبت شده است")
          }
          else {

            this.inner_PM.id = data.id
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.
        }
      )
    }

  }


}
